// extracted by mini-css-extract-plugin
module.exports = {"pin":"e_08","pinOn":"e_18","icon":"e_28","tile":"e_38","iconOnly":"e_48","label":"e_58","tileSub":"e_68","tileNames":"e_78","tileGo":"e_88"};